(function UpcomingDepartures($, Adzuki)
{
	"use strict";

	var form = {
		name: 'ReportUpcomingDepartures',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.onload('Reports/upcomingDepartures', function onload()
		{

			var $form,
				_resetVendor,
				_selectVendor;

			$form = $(form.element);

			Adzuki.Typeahead(
				'#reportupcomingdepartures-vendor_search',
				'/Vendors/search',
				function select(item, $self, typeahead) {
					typeahead.setHiddenValue(item.id);

					_selectVendor(item);
				}
			);

			$('.reset-vendor').click(function resetClicked(e) {
				e.preventDefault();

				$('#reportupcomingdepartures-vendor_search').val('');
				$('#reportupcomingdepartures-vendor_id').val('');
			});

			_resetVendor = function _resetVendor()
			{
				$form.find('.vendor-details').addClass('hidden');
			};

			_selectVendor = function _selectVendor(vendor)
			{
				_resetVendor();

				$('#reportupcomingdepartures-vendor_id').val(vendor.id);

				$form.find('.vendor-details').removeClass('hidden');
			};

		});
	});
}(jQuery, window.Adzuki || {}));
